import { createFileRoute } from "@tanstack/react-router";

import { ActivityView } from "@/shared/components/ActivityView";

export const Route = createFileRoute("/_authenticated/documents/activity")({
  component: ActivityView,
  context: () => ({ permissions: "document.activity" }),
});
